export default "__VITE_ASSET__B0OXGP_a__"